module.exports = __webpack_public_path__ + "img/fukumatuya.8f775c06.jpg";